import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { closeViewProposal } from '../../../store/actions/viewProposalActions';
import { withFirestore } from 'react-redux-firebase';
import {
  rejectDeal,
  requestRevision,
  acceptDeal
} from '../../../store/actions/dealActions';

const styles = theme => ({
  list: {
    minWidth: '550px',
    width: 550,
    [theme.breakpoints.down('xs')]: {
      width: 350
    }
  },
  gridContainer: {
    padding: '50px'
  },
  title: {
    maxWidth: '300px',
    display: 'flex'
  },
  contentSection: {
    marginTop: '30px'
  },
  acceptButton: {
    marginTop: '30px',
    color: 'white'
  },
  icon: {
    color: '#5DBE76',
    marginRight: '20px',
    marginLeft: '100px'
  },
  dealsLink: {
    color: '#22c26e',
    display: 'inline'
  },
  spinnerContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    background: 'white',
    zIndex: '1000',
    opacity: '.5'
  },
  downArrow: {
    display: 'block',
    margin: '0 auto'
  },
  swipeableViews: {
    minWidth: '550px',
    width: 550,
    [theme.breakpoints.down('xs')]: {
      width: 350
    }
  },
  noPastProposals: {
    height: '100%',
    justifyContent: 'center'
  },
  pastProposalsContainer: {
    padding: '50px',
    marginBottom: '50px',
    cursor: 'pointer'
  },
  addIcon: {
    marginBottom: '5px',
    marginRight: '5px'
  },
  detailsRow: {
    marginBottom: '10px'
  },
  detailTitle: {
    fontWeight: '600'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    rejectDealHandler: (dealId, userId) => dispatch(rejectDeal(dealId, userId)),
    acceptDealHandler: (dealId, updaterId, onComplete) =>
      dispatch(acceptDeal(dealId, updaterId))
        .then(() => {
          onComplete();
        })
        .catch(() => {
          onComplete();
        })
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirestore,
  withProps(({ auth, profile }) => ({
    auth,
    profile
  })),
  withRouter,
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/deals/proposals/ViewProposal.enhancer.js